import {
    trigger,
    transition,
    style,
    query,
    group,
    animateChild,
    animate,
    keyframes,
  } from '@angular/animations';

export const appRouteAnimations =
    trigger('routeAnimations', [
        transition('* <=> *', [
            query(':enter, :leave', [
                style({
                opacity: 0
                })
            ], { optional: true }),
            query(':enter', [
                animate('.6s ease', style({ opacity: 1 })),
            ], { optional: true }),
        ])

    ]);